import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { cn } from "@/utils";
import { ArrowUp, Globe, X } from "lucide-react";
import { useState } from "react";

interface CanvasAddLinkPopoverProps {
  onClose: () => void;
  onSubmit: (url: string) => void;
}

export function CanvasAddLinkPopover({
  onClose,
  onSubmit,
}: CanvasAddLinkPopoverProps) {
  const [url, setUrl] = useState("");

  const handleSubmit = () => {
    const trimmed = url.trim();
    if (!trimmed) return;
    onSubmit(trimmed);
    setUrl("");
    onClose();
  };

  return (
    <div
      className="z-20 w-[360px] max-w-[calc(100vw-2rem)]"
      data-canvas-control
      onMouseDown={(e) => e.stopPropagation()}
      onClick={(e) => e.stopPropagation()}
    >
      <div
        className={cn(
          "overflow-hidden rounded-xl border border-n-10 bg-n-00 shadow-elev-5",
        )}
      >
        <div className="flex items-center gap-2 border-b border-n-10 px-3 py-2.5">
          <Globe className="size-4 text-n-70" />
          <span className="text-sm font-medium">New Link</span>
          <button
            type="button"
            onClick={onClose}
            className="ml-auto rounded-sm p-1 text-n-50 hover:bg-n-10 hover:text-n-90"
            aria-label="Close"
          >
            <X className="size-4" />
          </button>
        </div>
        <div className="p-3">
          <div className="relative w-full">
            <Input
              autoFocus
              type="url"
              placeholder="https://..."
              value={url}
              onChange={(e) => setUrl(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter" && url.trim()) {
                  e.preventDefault();
                  handleSubmit();
                }
                if (e.key === "Escape") {
                  e.preventDefault();
                  onClose();
                }
              }}
              className="h-9 rounded-full pr-10 text-sm"
            />
            <Button
              size="icon"
              onClick={handleSubmit}
              disabled={!url.trim()}
              className="absolute right-1 top-1/2 size-7 -translate-y-1/2 rounded-full"
            >
              <ArrowUp className="size-3.5" />
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
